"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var getInputValue = function getInputValue(ev) {
  var _ev$target = ev.target,
    type = _ev$target.type,
    value = _ev$target.value,
    checked = _ev$target.checked,
    name = _ev$target.name;
  if (type === 'checkbox') {
    return {
      name: name,
      checked: checked
    };
  }
  return {
    name: name,
    value: value
  };
};
var _default = exports["default"] = getInputValue;